import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";

interface RecruiterInfoProps {
  createdBy: {
    fullName: string | null;
    avatarUrl: string | null;
  };
  recruiterProfile?: {
    headline?: string | null;
    company?: string | null;
  } | null;
}

export const RecruiterInfo = ({ createdBy, recruiterProfile }: RecruiterInfoProps) => {
  return (
    <div className="flex items-start gap-4 p-4 bg-muted/50 rounded-lg">
      <Avatar className="h-16 w-16">
        <AvatarImage src={createdBy.avatarUrl || ''} />
        <AvatarFallback>{createdBy.fullName?.charAt(0) || 'CD'}</AvatarFallback>
      </Avatar>
      <div>
        <h3 className="text-lg font-semibold">{createdBy.fullName}</h3>
        <p className="text-sm text-muted-foreground">{recruiterProfile?.headline}</p>
        {recruiterProfile?.company && (
          <p className="text-sm text-muted-foreground mt-1">{recruiterProfile.company}</p>
        )}
      </div>
    </div>
  );
};